<template>
  <main class="marketing-email-edit-verify">
    <loading v-if="loading"
             class="marketing-email-edit-verify-loading" />

    <app-form v-else
              @submit="advanceStep">
      <marketing-email-form-verify v-if="item"
                                   :item="item"
                                   :view-only="viewOnly"
                                   is-edit
                                   @saved="setItem" />

      <div class="marketing-email-edit-verify-actions">
        <button class="btn btn-primary btn-extra-round"
                type="submit">
          {{ submitText }}
        </button>
      </div>
    </app-form>
  </main>
</template>

<script>
import Loading from "@/components/generic/Loading.vue";
import AppForm from "@components/form/Form.vue";
import MarketingEmailFormVerify from "@components/modules/marketing/email/form/verify/MarketingEmailFormVerify";

export default {
  components: {
    MarketingEmailFormVerify,
    AppForm,
    Loading,
  },

  data() {
    return {
      item: undefined,
      isAutomationFlow: false,
      loading: false,
    };
  },

  created() {
    this.fetchEmail();
  },

  computed: {
    submitText() {
      return this.isAutomationFlow ? this.$t('message.email.message.finish') : this.$t('message.generics.message.advance');
    },
    viewOnly() {
      return this.$store.state.marketing.email.edit.viewOnly;
    },
  },

  mixins: [],

  methods: {
    setItem(item) {
      this.item = item;
    },
    async advanceStep() {
      if (!this.viewOnly) {
        this.saveDraft();
      }

      if (this.isAutomationFlow) {
        this.$router.push({
          path: "/marketing/email/",
        });
      } else {
        this.$store.commit("SET_EMAIL_CREATE_STEP", 4);

        this.$router.push({
          path: `/marketing/email/editar/${this.item.id}/envio`,
        });
      }
    },
    async saveDraft() {
      await this.$api.marketing.email.message.edit({
        emailId: this.item.id,
        data: {
          ...this.item,
        },
      });
    },
    async fetchEmail() {
      this.loading = true;

      const emailId = this.$route.params.emailId;

      const email = await this.$api.marketing.email.message.get({
        emailId,
      });

      this.isAutomationFlow = email.isAutomationFlow;
      this.$store.commit("EMAIL_EDIT_SET_AUTOMATION", email.isAutomationFlow);

      this.item = email;

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-edit-verify {
  .marketing-email-edit-verify-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }

  .marketing-email-edit-verify-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 50px 0;
  }
}
</style>
